var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpeaker = function SvgSpeaker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.166 9.115h-3.437v1.146h3.437zM17.499 4.036l-2.977 1.719.572.992 2.978-1.718zM15.094 12.63l-.572.992 2.976 1.719.573-.992zM13.129 1.732a.57.57 0 0 0-.593.038L6.955 5.678H3.984a3.155 3.155 0 0 0-3.151 3.15 3.155 3.155 0 0 0 3.151 3.152h2.97l5.582 3.906a.571.571 0 0 0 .901-.469V2.24a.57.57 0 0 0-.308-.508"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.978 13.126H4.187l2.259 5.01a1.256 1.256 0 0 0 2.292-1.023z"
  })));
};
export default SvgSpeaker;